import {Image} from 'antd'
import React, {useContext} from 'react'
import useToggle from 'react-use/lib/useToggle'
import ImagesLightBox from '../ImagesLightBox/ImagesLightBox'
import {LayoutContext} from "../layouts/Default/LayoutContext";
import Pure from "../Pure";
import {HiViewfinderCircle} from "react-icons/hi2";

export function ImageEmbed({image}) {
    const [open, toggle] = useToggle()
    const {isSm} = useContext(
        LayoutContext
    )
    return (
        <>
            <div
                onClick={toggle}
                style={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }}
                className="relative w-full background-200 overflow-hidden">
                <Pure input={[image]}>
                    <Image
                        wrapperClassName="w-full"
                        className="w-full object-cover "
                        style={{maxHeight: '68Vh'}}
                        src={image}
                        preview={{
                            mask: (
                                <div className="w-full h-full relative">
                                    <HiViewfinderCircle
                                        size={16}
                                        style={{top: 10, right: 10}}
                                        className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                    />
                                </div>
                            ),
                        }}
                    />
                </Pure>
            </div>
            {open && (
                <ImagesLightBox
                    images={[image]}
                    onCloseRequest={toggle}
                />
            )}
        </>
    )
}
